/**
 * Sichere Dateinamen für den Ablagebereich (Storage).
 *
 * Der Ablagebereich akzeptiert nur einfache Zeichen im Schlüssel. Umlaute,
 * Akzente, Leerzeichen und Sonderzeichen führen sonst zu „Invalid key".
 * Der Originalname bleibt in der Datenbank erhalten; hier wird nur der Pfad
 * bereinigt.
 */

const REPLACEMENTS: Record<string, string> = {
  ß: "ss",
  æ: "ae",
  ø: "oe",
  å: "aa",
  đ: "d",
  ł: "l",
  þ: "th",
  ð: "d",
};

function normalizePart(input: string): string {
  return input
    .toLowerCase()
    .replace(/[ßæøåđłþð]/g, (c) => REPLACEMENTS[c] ?? c)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function sanitizeStorageFilename(name: string): string {
  const raw = (name ?? "").trim();
  const match = /\.([A-Za-z0-9]{1,12})$/.exec(raw);
  const ext = match ? normalizePart(match[1]!) : "";
  const base = normalizePart(match ? raw.slice(0, match.index) : raw).slice(0, 180);
  const safeBase = base || "datei";
  return ext ? `${safeBase}.${ext}` : safeBase;
}
